import parlors from "goi_common/src/constants/parlors_detail.json";
import crematoriums from "goi_common/src/constants/hwajang_detail.json";
import facilities from "goi_common/src/constants/facilities_detail.json";
import { parlorRegion } from "@/constants/parlorRegion";
import {
  BTypeParlorCompare,
  ColorIcon,
  GOI_WEB_URL,
  Link,
  Spacing,
  call,
  colors,
  customEvent,
} from "goi_common";
import { Box, Stack } from "@mui/material";
import Head from "next/head";

import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";

import { GetServerSideProps } from "next/types";
import { useRouter } from "next/router";
const { targetSidos } = parlorRegion;

const getFuneralProcessRecommendPathList = () => {
  const parlorList = parlors.filter((res) => targetSidos.includes(res.sido));
  const cremaList = crematoriums.filter((res) =>
    targetSidos.includes(String(res.sido))
  );
  const facilityList = facilities.filter((res) =>
    targetSidos.includes(String(res.sido))
  );

  let pathList = [] as Array<any>;

  parlorList.forEach((parlor) => {
    cremaList.forEach((crema) => {
      if (parlor.sido == String(crema.sido)) {
        facilityList.forEach((facility) => {
          if (parlor.sido == facility.sido) {
            pathList.push({
              params: {
                parlor: parlor,
                crema: crema,
                facility: facility,
              },
            });
          }
        });
      }
    });
  });

  return pathList;
};

export const getServerSideProps: GetServerSideProps = async ({ query }) => {
  const pathList = getFuneralProcessRecommendPathList();
  const { pageNum } = query;
  const page = Number(pageNum);

  const showList = pathList
    .slice((page - 1) * ITEM_LIMIT, Number(pageNum) * ITEM_LIMIT)
    .map(({ params }) => ({ ...params }));

  const totalPageNum = Math.ceil(pathList.length / ITEM_LIMIT);

  const parlorName = showList[0].parlor.companyname
  const cremaName = showList[0].crema.companyname
  const facilityName = showList[0].facility.companyname
  

  const description = `전라 광주 지역 장례식장 화장장 장지 추천 ${page}번 조합입니다. 내부 구성 장례식장: ${parlorName}, 화장장: ${cremaName}, 장지: ${facilityName}, 총 ${totalPageNum} 개의 목록이 있으니 가장 합리적이게 장례를 진행하시길 바랍니다. :: 전라광주장례추천포털`;
  const title = `장례식장 화장장 장지 추천 조합 목록 ${pageNum}번 장례식장:${parlorName}, 화장장:${cremaName}, 장지:${facilityName} :: 전라광주장례추천포털`;

  return {
    props: {
      pageOgTitle: title,
      pageDescription: description,
      pageOgDescription: description,
      paths: showList,
      totalPageNum,
    },
  };
};

type StringKeyObject = { [key: string]: any };

interface FuneralProcessRecommendIndexPages {
  paths: {
    parlor: StringKeyObject;
    crema: StringKeyObject;
    facility: StringKeyObject;
  }[];
  totalPageNum: number;
}

const ITEM_LIMIT = 100;
const PAGE_PATH = "fune_proc_recom_list";

const FuneralProcessRecommendPages = ({
  paths,
  totalPageNum,
}: FuneralProcessRecommendIndexPages) => {
  const router = useRouter();
  const { pageNum } = router.query as { pageNum: string };

  return (
    <>
      <Head>
        <link
          rel="canonical"
          href={`https://www.honam-funeralcenter.co.kr/funeral-process-recommend/list/${pageNum}/`}
          key="canonical"
        />
        {/* <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(faqList) }}
        /> */}
      </Head>

      <Stack>
        <Stack
          flexDirection="row"
          justifyContent="center"
          gap="44px"
          padding="24px 0 60px"
        >
          <Stack
            alignItems="center"
            onClick={() => {
              call("1666-9784");
              customEvent({
                domain: "honam",
                path: PAGE_PATH,
                trigger_and_target: "goi_call",
              });
            }}
          >
            <ColorIcon name="symbol-call" size={56} color="black" />
            <Box className="subtitle_14_sb">긴급 장례 상담</Box>
          </Stack>
          <Box
            height="65px"
            width="1px"
            style={{ background: colors.gray500 }}
          />
          <Link
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
            href={GOI_WEB_URL + "/service/flower/"}
            event={{
              domain: "honam",
              path: PAGE_PATH,
              trigger_and_target: "uv_wreath_req",
            }}
          >
            <ColorIcon name="flower-line" size={56} color="black" />
            <Box
              className="subtitle_14_sb black"
              style={{ textDecoration: "none" }}
            >
              화환 2시간 배송
            </Box>
          </Link>
        </Stack>

        <Stack alignItems="center" className="subtitle_16_b gray900" mb="6px">
          <h2>전라 광주 장례식장/화장장/장지 조합을 추천드립니다. </h2>
          <Spacing gap={20} />
          <Stack gap="20px">
            {paths.map(({ parlor, crema, facility }, index) => {
              const key = `parlor${parlor.id}_crema${crema.id}_facility${facility.id}`;
              const href = `/funeral-process-recommend/${parlor.companyname}/${crema.companyname}/${facility.companyname}/`;
              const linkTitle = `${parlor.companyname} x ${crema.companyname} x ${facility.companyname} 추천조합`;

              return (
                <Link
                  key={key}
                  href={href}
                  title={linkTitle}
                  event={{
                    domain: "honam",
                    path: PAGE_PATH,
                    trigger_and_target: "uv_fune_proc_recom",
                  }}
                >
                  <Box
                    className="gray600"
                    style={{
                      background: "white",
                      boxShadow: "0px 0px 12px 0px rgba(0, 0, 0, 0.12)",
                      borderRadius: "5px",
                      padding: "20px",
                    }}
                  >
                    <BTypeParlorCompare
                      firstParlor={parlor}
                      secondParlor={crema}
                      twiceParlor={facility}
                      index={index}
                    />
                  </Box>
                </Link>
              );
            })}
          </Stack>
        </Stack>

        <Stack
          flexDirection="row"
          justifyContent="center"
          gap="44px"
          padding="24px 0 60px"
        >
          <Pagination
            count={totalPageNum}
            page={Number(pageNum)}
            renderItem={(item) => {
              if (
                item.page === null ||
                !item.page ||
                item.page > totalPageNum
              ) {
                return <PaginationItem {...item} />;
              }

              return (
                <Link
                  href={`/funeral-process-recommend/list/${item.page}`}
                  event={{
                    domain: "honam",
                    path: PAGE_PATH,
                    trigger_and_target: "uv_fune_proc_recom_list",
                  }}
                >
                  <PaginationItem {...item} />
                </Link>
              );
            }}
          />
        </Stack>
        <Spacing gap={40} />
      </Stack>
    </>
  );
};

export default FuneralProcessRecommendPages;
